import { supabase } from '../../client';
import { MemberPreference } from '../types/memberPreference';

/**
 * 현재 사용자의 preference 행을 조회합니다. (RLS로 own 행만 보임. 없으면 null)
 */
export async function findOwn(): Promise<MemberPreference | null> {
  const { data, error } = await supabase
    .from('member_preference')
    .select('*')
    .maybeSingle();

  if (error) throw error;
  return data;
}

/**
 * record_payment_method를 upsert합니다. (행이 없으면 생성)
 */
export async function upsertRecordPaymentMethod(userId: string, value: boolean): Promise<void> {
  const { error } = await supabase
    .from('member_preference')
    .upsert({ user_id: userId, record_payment_method: value }, { onConflict: 'user_id' });

  if (error) throw error;
}

/**
 * shipping_excel_sort를 upsert합니다. (행이 없으면 생성 — record_payment_method는 DB default false)
 */
export async function upsertShippingExcelSort(userId: string, value: 'entry' | 'settlement'): Promise<void> {
  const { error } = await supabase
    .from('member_preference')
    .upsert({ user_id: userId, shipping_excel_sort: value }, { onConflict: 'user_id' });

  if (error) throw error;
}
